import React, { forwardRef } from 'react';
import { Box } from '@chakra-ui/react';
import { Field } from '../ui/field';
import { FaChevronDown } from 'react-icons/fa';

export const CustomSelect = forwardRef(({ label, error, options, placeholder, required, children, ...props }, ref) => {
  return (
    <Field 
      label={label} 
      invalid={!!error} 
      errorText={error?.message || error} 
      required={required}
      width="100%"
      mb={4} // Add margin bottom for spacing
    >
      <Box position="relative" width="100%">
        <Box 
          as="select" 
          width="100%" 
          padding="12px 16px" // Increased padding
          paddingRight="40px" // Space for the icon
          borderRadius="8px" 
          border="1px solid" 
          borderColor={error ? "red.500" : "gray.300"}
          _hover={{ borderColor: "blue.400" }}
          _focus={{ borderColor: "blue.500", outline: "none", boxShadow: "0 0 0 1px #3182ce" }}
          bg="white"
          fontSize="md"
          appearance="none" // Remove default arrow
          ref={ref} 
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options && options.map(opt => (
              typeof opt === 'string' ? 
              <option key={opt} value={opt}>{opt}</option> :
              <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
          {children}
        </Box>
        <Box 
          position="absolute" 
          right="16px" 
          top="50%" 
          transform="translateY(-50%)" 
          pointerEvents="none"
          color="gray.500"
        >
          <FaChevronDown size="12px" />
        </Box>
      </Box>
    </Field>
  );
});
